import { render, staticRenderFns } from "./EventWinPage.vue?vue&type=template&id=be84386e&"
import script from "./EventWinPage.vue?vue&type=script&lang=js&"
export * from "./EventWinPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports